export function calculateBulletTranslate(
  currentItemIndex: number,
  itemsLength: number,
  size: number
) {
  if (itemsLength !== 1 && itemsLength <= 3) {
    return 0;
  }

  if (itemsLength < 6 || currentItemIndex < 3) {
    return 0;
  }

  if (currentItemIndex > itemsLength - 4) {
    return size * (5 - itemsLength);
  }

  return size * (2 - currentItemIndex);
}
